import React, { useEffect, useState, useCallback, useMemo } from "react";
import { Card, Table, Dropdown, Modal, Divider, Typography } from "antd";
import { EyeOutlined, LockOutlined, MoreOutlined } from "@ant-design/icons";
import EnquiryStatusTags from "./EnquiriesStatus";
import { capitalize } from "lodash";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { formatDate, isLessThan24Hrs } from "util/helper";
import { isArrayNonEmpty, isValidString } from "../../util/ApiHelper";
import { EnquiryStatus } from "util/Constant";
import { fetchStart, fetchSuccess } from "../../appRedux/actions";
import { axiosInstance } from "util/Api";
import { BASE_API_CONFIG } from "./../../util/Api";
import { getBusinessBasedEnquiryTableColumns } from "./utils";
import ListEmptyComponent from "../../components/ListEmptyComponent/ListEmptyComponent";
import { useGetBreakpoints } from "../../hooks/useGetBreakpoints";
import { ItemDetailMobile } from "../../components/ItemDetailMobile";
import { isManufacturer, isExporter, isCommissionAgent } from "../../util/helper";
import AppNotificationContainer from "../../components/AppNotificationContainer";
import { getProductsAction } from "../../appRedux/actions/myProductsAction";
import { useLocation } from "react-router-dom";
import { BUSINESS_TYPE, LEAD_TITLE ,LEAD_DIFFER_DAYS, RFQStatus } from "../../util/Constant";

const getStatus = (data) => {
  if (
      data.status === RFQStatus.CONFIRMED ||
      data.status === RFQStatus.OFFER_REJECTED ||
      data.status === RFQStatus.SUBMITTED
    ) {
      return data.status;
    }

  return (
    data?.readReciept[0]?.status ??
    (isLessThan24Hrs(data?.createdAt)
      ? EnquiryStatus.NEW_ENQUIRY
      : EnquiryStatus.AWAITING_FOR_QUOTATION)
  );
};

const lessThenSevenDays =(dateString) =>{
  const today =new Date();
  const date = new Date(dateString);
  const differInDays = Math.floor((today-date)/(1000*60*60*24));
  return differInDays <= LEAD_DIFFER_DAYS.DAYS;
}

const EnquiriesList = ({ fromDashboard,defaultRole  }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { isMobile } = useGetBreakpoints();
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null);
  const [unmatchedLeadsPage, setUnmatchedLeadsPage] = useState(1);
  const [matchedLeadsPage, setMatchedLeadsPage] = useState(1);

  const [currentPage, setCurrentPage] = useState(1);

  // const currentPage = 1;
  const dataSize = fromDashboard ? 5 : 10;
  const [tableData, setTableData] = useState();
  console.log("tableData", tableData)
  const [loading, setLoading] = useState();

  const authUser = useSelector(({ auth }) => auth.userData);
  const authUserId = useSelector(({ auth }) => auth?.userData?.businessTypeId);
  console.log("authUserId",authUserId)
  const productList = useSelector((state) => state.myProducts.productsList);
  console.log("productList",productList)
  const [pageSize, setPageSize] = useState(fromDashboard ? 5 : 10);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const role = queryParams.get("role") || defaultRole || "general";

  const tableTitle = useMemo(() => {
    if (role === BUSINESS_TYPE.BUYER) {
      return LEAD_TITLE.BUYER_LEADS;
    } else if (role === BUSINESS_TYPE.EXPORTER) {
      return LEAD_TITLE.EXPORTER_LEADS;
       } else if (role === BUSINESS_TYPE.CUSTOM_HOUSE_AGENT) {
      return LEAD_TITLE.CUSTOM_HOUSE_AGENT_LEADS;
       } else if (role === BUSINESS_TYPE.FREIGHT_FORWARDER) {
      return LEAD_TITLE.FREIGHT_FORWARDER_LEADS;
    } else {
      return LEAD_TITLE.LEADS;
    }
  }, [role]);
  useEffect(() => {
    dispatch(getProductsAction());
  }, [dispatch]);

  const isFreightUser = authUserId === 6; 
  const isFreightUsers = authUser?.businessType === 'freight_forwarder';
const isCHAUser = authUser?.businessType === 'custom_house_agent';
const isCombinedUser = authUser?.businessType === 'customhouseagents_freightforwarder';
const shouldShowAllLeads = isCombinedUser ||  isFreightUsers || isCHAUser;

console.log("shouldShowAllLeads",shouldShowAllLeads)

const hasProducts = useMemo(() => {
  // Freight forwarders and CHA don't need products to see leads
  if (shouldShowAllLeads) {
    return true;
  }
  return isArrayNonEmpty(productList?.rows);
}, [productList, shouldShowAllLeads]);
console.log("hasProducts", hasProducts)
  // const userLoadingPorts = useMemo(() => {
  //   if (!isFreightUser) return [];
  //       if (!authUser?.loadingPort) return [];
    
  //   try {
  //     if (Array.isArray(authUser.loadingPort)) return authUser.loadingPort;
      
  //     if (typeof authUser.loadingPort === 'string' && 
  //         (authUser.loadingPort.startsWith('[') || authUser.loadingPort.startsWith('{'))) {
  //       return JSON.parse(authUser.loadingPort);
  //     }
      
  //     return [authUser.loadingPort].filter(Boolean);
  //   } catch (e) {
  //     return [authUser.loadingPort].filter(Boolean);
  //   }
  // }, [authUser?.port, isFreightUser]);

  // const userDestinationPorts = useMemo(() => {
  //   if (!isFreightUser) return [];
  //       if (!authUser?.port) return [];
    
  //   try {
  //     if (Array.isArray(authUser.port)) return authUser.port;
      
  //     if (typeof authUser.port === 'string' && 
  //         (authUser.port.startsWith('[') || authUser.port.startsWith('{'))) {
  //       return JSON.parse(authUser.port);
  //     }
      
  //     return [authUser.port].filter(Boolean);
  //   } catch (e) {
  //     return [authUser.port].filter(Boolean);
  //   }
  // }, [authUser?.port, isFreightUser]);

  // const normalizePort = (port) => {
  //   if (!port) return '';
  //   return port
  //     .split(/(\(|\[)/)[0]  
  //     .trim()
  //     .toLowerCase()
  //     .replace(/[^a-z0-9 ]/g, '') 
  //     .replace(/\s+/g, ' ')       
  //     .trim();
  // };
  
  // const filteredLeads = useMemo(() => {
  //   if (!isFreightUser || !tableData?.rows) return { 
  //     matchingLeads: [], 
  //     nonMatchingLeads: [] 
  //   };
  
  
  //   return tableData.rows.reduce((acc, lead) => {
  //     const leadLoading = normalizePort(lead.sourcePort);
  //     const leadDest = normalizePort(lead.destinationPort);
  
  //     const userLoadingNormalized = userLoadingPorts.map(normalizePort);
  //     const userDestNormalized = userDestinationPorts.map(normalizePort);
  
  //     console.log("Checking lead:", {
  //       id: lead.id,
  //       raw: {
  //         loading: lead.sourcePort,
  //         dest: lead.destinationPort
  //       },
  //       normalized: {
  //         loading: leadLoading,
  //         dest: leadDest
  //       }
  //     });
  
  //     const loadingExactMatch = userLoadingNormalized.includes(leadLoading);
  //     const destExactMatch = userDestNormalized.includes(leadDest);
  
  //     const loadingPartialMatch = userLoadingNormalized.some(userPort => 
  //       userPort.includes(leadLoading) || leadLoading.includes(userPort)
  //     );
      
  //     const destPartialMatch = userDestNormalized.some(userPort => 
  //       userPort.includes(leadDest) || leadDest.includes(userPort)
  //     );
  
  //     const isMatch = (loadingExactMatch && destExactMatch) || 
  //                  (loadingPartialMatch && destPartialMatch);
  
  //     // Debug: Log match results
  //     console.log("Match results:", {
  //       loadingExactMatch,
  //       destExactMatch,
  //       loadingPartialMatch,
  //       destPartialMatch,
  //       finalMatch: isMatch
  //     });
  
  //     if (isMatch) {
  //       acc.matchingLeads.push({ 
  //         ...lead,
  //         matchDetails: {
  //           loadingExactMatch,
  //           destExactMatch,
  //           loadingPartialMatch,
  //           destPartialMatch
  //         }
  //       });
  //     } else {
  //       acc.nonMatchingLeads.push(lead);
  //     }
  
  //     return acc;
  //   }, { matchingLeads: [], nonMatchingLeads: [] });
  // }, [tableData, userLoadingPorts, userDestinationPorts, isFreightUser]);


  const userRestriction = useMemo(() => {
  // Don't apply product restrictions to freight/CHA users
  if (shouldShowAllLeads) {
    return false;
  }
  return !isArrayNonEmpty(productList?.rows) &&
    (isManufacturer(authUser) ||
      isExporter(authUser) ||
      isCommissionAgent(authUser));
}, [productList, authUser, shouldShowAllLeads]);

      const navigateToDetails = useCallback(
        (id, qid) => {
          if (isValidString(id) && isValidString(qid)) {
            history.push(`enquiries/details?id=${id}&qid=${qid || ""}&role=${role}`);
          } else if (isValidString(id)) {
            history.push(`enquiries/details?id=${id}&role=${role}`);
          }
          console.log(role)
        },
        [history]
      );

  // const handleNavigation = useCallback((record, isLocked = false) => {
  //   if (isLocked && isFreightUser) {
  //     setSelectedLead(record);
  //     setModalVisible(true);
  //   } else {
  //     navigateToDetails(record?.id, record?.readReciept[0]?.quotationId);
  //   }
  // }, [navigateToDetails, isFreightUser]);

   const handleNavigation = useCallback((record) => {
    navigateToDetails(record?.id, record?.readReciept[0]?.quotationId);
  }, [navigateToDetails]);

  const getColumns = useMemo(() => {
    const baseColumns = [
      {
        title: "Posted Date",
        key: "createdAt",
        render: (record) => <div>{formatDate(record?.createdAt)}</div>,
      },
      {
        title: "Product Name",
        key: "productName",
        sorter: true,
        render: (record) => <div>{record?.productName}</div>,
      },
      ...(isFreightUser
        ? [
            {
              title: "Loading Port",
              key: "sourcePort",
              render: (record) => record?.sourcePort || "N/A",
            },
          ]
        : []),
      {
        title: "Quantity",
        key: "quantityRequired",
        render: (record) => (
          <div 
          style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {record?.qty ? (
              <>
                {record?.qty} {record?.units}
              </>
            ) : (
              <>
                {record?.noOfContainers}{" "}
                {record?.noOfContainers === 1 ? "Container" : "Containers"}
              </>
            )}
          </div>
        ),
        width: 150,
      },
      // {
      //   title: "RFQ Type",
      //   key: "rfqType",
      //   sorter: true,
      //   render: (record) => <div>{record?.rfqType ?? "-"}</div>,
      // },
      {
        title: "Status",
        key: "Status",
        sorter: true,
        render: (record) => {
          let status = getStatus(record);
          return <EnquiryStatusTags status={status} />;
        },
      },
      {
        title: "Actions",
        key: "actions",
        render: (record) => (
        <div
            className="myexim-action-icon"
            onClick={(e) => e.stopPropagation()}
          >
            <Dropdown
              menu={{
                items: [
                  {
                    label: record?.canAccessDetails === false ? "Unlock Details" : "View Details",
                    key: "1",
                    icon: record?.canAccessDetails === false ? <LockOutlined /> : <EyeOutlined />,
                    onClick: () => {
                      handleNavigation(record);
                    },
                  },
                ],
              }}
              trigger={["click"]}
            >
              <MoreOutlined />
            </Dropdown>
          </div>
        ),
      },
    ];
    const newColumns = [...baseColumns];
  
    if (
      authUserId !== 3 &&
      authUserId !== 4 &&
      role !== BUSINESS_TYPE.EXPORTER
    ) {
      newColumns.splice(3, 0, {
        title: "Destination Country",
        key: "destinationCountry",
        align: "center",
        render: (record) => <div>{record?.destinationCountry || "-"}</div>,
      });
      newColumns.splice(4, 0, {
        title: "Destination Port",
        key: "destinationPort",
        align: "center",
        render: (record) => <div>{record?.destinationPort || "-"}</div>,
      });
    }
    
    return newColumns;
  }, [authUserId, role, handleNavigation]);


  // Data fetching
  const fetchEnquiries = useCallback(async (page, limit) => {
    try {
      dispatch(fetchStart());
      console.log("Role ", role)
      const response = await axiosInstance.get(
        `${BASE_API_CONFIG.baseURL}/enquiries/businessType?page=${page}&limit=${limit}&role=${role}`
      );


console.log("role role",role)
console.error("Responce From enquiries:", response?.data?.data);
console.error("Responce fetching enquiries:", role);
        console.log('API Response:', response?.data);
    console.log('User Business Type:', authUser?.businessType);
    // console.log('Should Show All Leads:', shouldShowAllLeads);
      //  const processedData = shouldShowAllLeads
      // ? response?.data?.data
      // : {
      //     ...response?.data?.data,
      //     rows: response?.data?.data?.rows?.filter(row => row.isMatched),
      //     count: response?.data?.data?.rows?.filter(row => row.isMatched).length
      //   };

      // const filteredData = response?.data.data.rows?.filter((record) => lessThenSevenDays(record?.createdAt));
      //   setLoading(false);
      //   setTableData({...response?.data?.data, rows:filteredData });

    // setTableData(processedData);
      const responseData = response.data.data;
    const rows = responseData?.rows || [];
    const count = responseData?.count || 0;

    const processedData = shouldShowAllLeads
      ? responseData
      : {
          ...response?.data?.data,
          rows: response?.data?.data?.rows?.filter(row => row.isMatched),
          count: response?.data?.data?.rows?.filter(row => row.isMatched).length
        };
      console.log("responseDataresponseData",responseData)
    // setTableData(processedData);
      setTableData(responseData);

    } catch (error) {
      console.error("Error fetching enquiries: From the Catch", error);
    } finally {
      dispatch(fetchSuccess());
      setLoading(false);
    }
  }, [dispatch, role, shouldShowAllLeads]);

  const onShowSizeChange = useCallback(
    (current, pageSize) => {
      setPageSize(pageSize);
      setCurrentPage(current);
      // dispatch(fetchEnquiries(current, pageSize));
      fetchEnquiries(current, pageSize);
    },
    [fetchEnquiries]
  );



  
  const renderMobileItem = (record, isLocked = false) => (
  <div 
    key={record.id}
    onClick={() => handleNavigation(record)}
  >
    <ItemDetailMobile
      postedDate={formatDate(record.createdAt)}
      primaryRow={{
        text: record.productName,
        subText: record.noOfContainers
          ? `${record.noOfContainers} Containers`
          : `${record.qty} ${record.units}`,
      }}
      secondaryRow={
        record.destinationPort
        ? {subText: `${capitalize(record.destinationPort)}, ${record.destinationCountry}`,}
        : undefined
      }
      status={getStatus(record)}
      StatusComponent={EnquiryStatusTags}
      isLocked={isLocked}
    />
  </div>
);

 const renderContent = useCallback(
    (data, count, activity, showEmptyNoteBasedOnRestriction) => {
  // if (isFreightUser) {
  //   return (
  //     <>
  //       <Modal
  //         title="Leads Locked"
  //         visible={modalVisible}
  //         onOk={() => setModalVisible(false)}
  //         onCancel={() => setModalVisible(false)}
  //         okText="OK"
  //         width={600}
  //       >
  //         <p>You don't have access to this lead because:</p>
  //         <ul>
  //           <li>Leads is not under your Handling Port/Destination Port</li>
  //           <li>Please add This Handling/Destination Port Under Profile Update</li>
  //         </ul>
  //         <p>
  //           To access this lead, please update your profile ports or contact support.
  //           <a href="my-profile"> Update Profile Now</a>
  //         </p>
  //       </Modal>

        <Card
          className={isMobile ? "mobile-view" : ""}
          title={<div className="myexim-table-title">{tableTitle}</div>}
        >

  {isArrayNonEmpty(data) ? (
            isMobile ? (
              data.map((record) => {
                return (
                  <ItemDetailMobile
                    postedDate={formatDate(record.createdAt)}
                    primaryRow={{
                      text: record.productName,
                      subText: 
                      record.noOfContainers
                      ? `${record.noOfContainers} Containers`
                      : `${record.qty} ${record.units}`,
                    }}
                    secondaryRow={{
                      // text: record.user.quatationsleft,
                      subText: `${capitalize(record.destinationPort)},${
                        record.destinationCountry
                      }`,
                    }}
                    status={getStatus(record)}
                    StatusComponent={EnquiryStatusTags}
                    handleNavigation={() => {
                      handleNavigation(record);
                    }}
                    isLocked={record?.canAccessDetails === false}
                  />
                );
              })
            ) : (
              <Table
                rowKey={"id"}
                rowClassName={(record, index) =>
                  index % 2 === 0 ? "table-row-light" : "table-row-dark"
                }
                onRow={(record) => {
                  return {
                    onClick: (e) => {
                      // Add specific conditions here for menu items
                      if (
                        !e.target.classList.contains(
                          "ant-dropdown-menu-title-content"
                        )
                      ) {
                        handleNavigation(record);
                      }
                    },
                  };
                }}
                className="gx-table-responsive rfq-table myexim-table"
                columns={getColumns.filter((obj) =>
                  getBusinessBasedEnquiryTableColumns(
                    authUser?.businessTypes?.code
                  )?.includes(obj.key)
                )}
                dataSource={data}
                pagination={
                  !fromDashboard && {
                    position: ["bottomRight"],
                    current: currentPage,
                    pageSize: pageSize,
                    showSizeChanger: true,
                    total: count,
                    onChange: onShowSizeChange,
                  }
                }
              />
            )
          ) : (
            !activity && (
              <ListEmptyComponent
                message={
                  showEmptyNoteBasedOnRestriction
                    ? "Create Your Products to get the Enquiries for your Listed Products"
                    : "At the moment, No Enquiries are Available. we will notify you when New Enquiries are received."
                }
                buttonText={
                  showEmptyNoteBasedOnRestriction
                    ? " + Create New Products"
                    : ""
                }
                onButtonClick={() => history.push("my-products/edit")}
              />
            )
          )}

          {/* Matched Leads Section */}
          {/* <div className="matched-section">
            <Typography.Title level={4} style={{ marginBottom: 13, marginLeft: 16 }}>
              Available Leads - {filteredLeads.matchingLeads.length}
            </Typography.Title>
            
            {isArrayNonEmpty(filteredLeads.matchingLeads) ? (
              isMobile ? (
                filteredLeads.matchingLeads.map(record => renderMobileItem(record))
              ) : (
                <Table
                  className="gx-table-responsive rfq-table myexim-table"
                  columns={getColumns}
                  dataSource={filteredLeads.matchingLeads}
                  rowKey={"id"}
                  rowClassName={(record, index) =>
                    index % 2 === 0 ? "table-row-light" : "table-row-dark"
                  }
                  onRow={(record) => ({
                    onClick: (e) => {
                      if (!e.target.classList.contains("ant-dropdown-menu-title-content")) {
                        handleNavigation(record);
                      }
                    },
                  })}
                  pagination={{
                    current: matchedLeadsPage,
                    pageSize: 10,
                    total: filteredLeads.matchingLeads.length,
                    onChange: (page) => setMatchedLeadsPage(page),
                    showSizeChanger: true
                  }}
                />
              )
            ) : (
              <div className="no-leads-message" style={{marginLeft: 17}}>
                <Typography.Text type="warning">
                  No matching leads found with your current port configuration
                </Typography.Text>
              </div>
            )}
          </div> */}
          
          {/* Unmatched Leads Section */}
          {/* {isArrayNonEmpty(filteredLeads.nonMatchingLeads) && (
            <>
              <Divider />
              <Typography.Title level={4} style={{ marginBottom: 16 ,marginLeft: 7 } }>
                <LockOutlined 
                  style={{ color: '#ff4d4f', fontSize: '22px', marginRight: 7 }} 
                /> 
                Locked Leads - {filteredLeads.nonMatchingLeads.length}
              </Typography.Title>
              
              {isMobile ? (
                filteredLeads.nonMatchingLeads.map(record => renderMobileItem(record, true))
              ) : (
                <Table
                  rowKey={"id"}
                  className="gx-table-responsive rfq-table myexim-table"
                  onRow={(record) => ({
                    onClick: () => {
                      setSelectedLead(record);
                      setModalVisible(true);
                    },
                  })}
                  columns={getColumns.filter(obj =>
                    getBusinessBasedEnquiryTableColumns(authUser?.businessTypes?.code)?.includes(obj.key)
                  )}
                  dataSource={filteredLeads.nonMatchingLeads}
                  pagination={!fromDashboard && {
                    position: ["bottomRight"],
                    pageSize: 10,
                    showSizeChanger: true,
                    total: filteredLeads.nonMatchingLeads.length,
                    current: unmatchedLeadsPage,
                    onChange: (page) => setUnmatchedLeadsPage(page),
                  }}
                />
              )}
            </>
          )} */}
        </Card>
      // </>
    // );
  // }

  // Original non-freight render
  return (

    <Card 
    // className={isMobile ? "mobile-view" : ""} 
        bodyStyle={{ padding: "24px" }}
        title={<div className="myexim-table-title">{tableTitle}</div>}>
      {isArrayNonEmpty(tableData?.rows) ? (
        isMobile ? (
          tableData.rows.map(record => renderMobileItem(record))
        ) : (
          <Table
            className="gx-table-responsive rfq-table myexim-table"
            rowClassName={(record, index) => {
                 return index % 2 === 0 ? "table-row-light" : "table-row-dark"
                }}
            columns={getColumns}
            dataSource={tableData.rows}
            rowKey={"id"}
            onRow={(record) => ({
            style: { cursor: "pointer" },
            onClick: () => {
                      handleNavigation(record);
                    },
             })}
            pagination={
                  !fromDashboard && {
                    position: ["bottomRight"],
                    current: currentPage,
                    pageSize: pageSize,
                    showSizeChanger: true,
                    total: count,
                    onChange: onShowSizeChange,
                  }
                }
          />
        )
      ) : (
        <ListEmptyComponent message="No enquiries available" />
      )}
    </Card>
  );
}, [
  isFreightUser,
  modalVisible,
  isMobile,
  tableTitle,
  tableData,
  fromDashboard,
  getColumns,
  onShowSizeChange,
  // filteredLeads,
  matchedLeadsPage,
  unmatchedLeadsPage,
  handleNavigation,
  authUser?.businessTypes?.code,
  isCombinedUser
]);




// const renderContent = useCallback(
//   (data, count, activity, showEmptyNoteBasedOnRestriction) => {
//     // Check if user has no products
//     if (!hasProducts) {
//       return (
//         <Card 
//           bodyStyle={{ padding: "24px" }}
//           title={<div className="myexim-table-title">{tableTitle}</div>}
//         >
//          <ListEmptyComponent
//             message="Create Your Products to get the Enquiries for your Listed Products"
//             buttonText="+ Create Your New Products"
//             onButtonClick={() => history.push("my-products/edit")}
//           />
  
//         </Card>
//       );
//     }

//     // Check if user has products but no leads
//     if (!isArrayNonEmpty(data)) {
//       return (
//         <Card 
//           bodyStyle={{ padding: "24px" }}
//           title={<div className="myexim-table-title">{tableTitle}</div>}
//         >
//           <ListEmptyComponent
//             message="No Leads Available"
//           />
    //     </Card>
    //   );
    // }

    // Render leads table if there are leads
//     return (
//       <Card 
//         bodyStyle={{ padding: "24px" }}
//         title={<div className="myexim-table-title">{tableTitle}</div>}
//       >
//         {isMobile ? (
//           data.map(record => renderMobileItem(record))
//         ) : (
//           <Table
//             className="gx-table-responsive rfq-table myexim-table"
//             rowClassName={(record, index) => {
//               return index % 2 === 0 ? "table-row-light" : "table-row-dark"
//             }}
//             columns={getColumns}
//             dataSource={data}
//             rowKey={"id"}
//             onRow={(record) => ({
//               style: { cursor: "pointer" },
//               onClick: () => {
//                 handleNavigation(record);
//               },
//             })}
//             pagination={!fromDashboard && {
//               position: ["bottomRight"],
//               pageSize: 10,
//               showSizeChanger: true,
//               total: count,
//               onChange: (page, pageSize) => onShowSizeChange(page, pageSize),
//             }}
//           />
//         )}
//       </Card>
//     );
//   },
//   [
//     hasProducts,
//     isMobile,
//     tableTitle,
//     fromDashboard,
//     getColumns,
//     onShowSizeChange,
//     handleNavigation
//   ]
// );

  useEffect(() => {
    setLoading(true);
    fetchEnquiries(currentPage, dataSize);
  }, [currentPage, dataSize, fetchEnquiries]);

  return !loading ? (
    renderContent(tableData?.rows, tableData?.count, loading, userRestriction)
  ) : (
    <AppNotificationContainer loading={loading} />    //renderContent()
  );
};

export default EnquiriesList;
